import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
@Component({
  selector: 'app-quotes-list',
  templateUrl: './quotes-list.component.html',
  styleUrls: ['./quotes-list.component.css']
})
export class QuotesListComponent {

  displayedColumns: string[] = ['sno', 'name', 'title', 'quoteStage', 'contact', 'account', 'grandTotal', 'validUntil'];
  dataSource = new MatTableDataSource<Quote>(QUOTES_DATA);

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  onChangeActive(event: any) {
    // const value = event.value;
    const value = (event.target as HTMLSelectElement).value;

    this.dataSource.data = QUOTES_DATA.filter(quote => {
      if (!value) return true;
      return quote.status?.toLowerCase() === value;
    });
  }
}

interface Quote {
  name: string;
  title: string;
  quoteStage: string;
  contact: string;
  account: string;
  grandTotal: number;
  validUntil: Date;
  status?: string; // active / inactive
}

// Mock Data
const QUOTES_DATA: any[] = [];
[
  {
    name: 'Quote A',
    title: 'Initial Proposal',
    quoteStage: 'Draft',
    contact: 'John Doe',
    account: 'Acme Inc',
    grandTotal: 10000,
    validUntil: new Date('2024-06-01'),
    status: 'active'
  },
  {
    name: 'Quote B',
    title: 'Final Deal',
    quoteStage: 'Approved',
    contact: 'Jane Smith',
    account: 'Globex Ltd',
    grandTotal: 25000,
    validUntil: new Date('2024-07-15'),
    status: 'inactive'
  }
];
